/**
 * Interractive star rating
 */

export default (() => {
  const form = document.getElementById('rating-form')
  if (form) {
    const ratingBlock = form.querySelector('.rating')
    const hiddenInput = ratingBlock?.querySelector('input[type="hidden"]')
    const errorMsg = form.querySelector('.error-msg')
    const firstStar = ratingBlock?.querySelector('button')

    if (ratingBlock && hiddenInput && errorMsg && firstStar) {
      ratingBlock.querySelectorAll('button').forEach((star) => {
        const value = star.dataset.value

        star.addEventListener('click', () => {
          ratingBlock.dataset.rating = value
          hiddenInput.value = value
          errorMsg.style.display = 'none'
        })

        star.addEventListener('mouseenter', () => {
          ratingBlock.dataset.hover = value
        })

        star.addEventListener('mouseleave', () => {
          delete ratingBlock.dataset.hover
        })
      })

      form.addEventListener('submit', (e) => {
        if (!hiddenInput.value || hiddenInput.value === '0') {
          e.preventDefault()
          errorMsg.style.display = 'block'
          ratingBlock.scrollIntoView({ behavior: 'smooth', block: 'center' })
          setTimeout(() => {
            firstStar.focus()
          }, 300)
        }
      })
    }
  }
})()
